<form [formGroup]="form">
  <app-tabs>
    <app-tab
      [title]="'connectionpoint.create.general'"
    >
      <div class="flex flex-col">
        <app-input-group>
          <label appLabel>{{ 'connectionpoint.title' | translate }}</label>
          <input
            appInput
            formControlName="identification"
            readonly
            placeholder="{{ 'connectionpoint.form.enterIdentification' | translate }}">
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'connectionpoint.alternativeIdentification' | translate }}</label>
          <input
            appInput
            formControlName="alternativeIdentification"
            placeholder="{{ 'connectionpoint.form.enterAlternativeIdentification' | translate }}">
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'connectionpoint.stationsNumber' | translate }}</label>
          <input
            appInput
            formControlName="stationNumber"
            placeholder="{{ 'connectionpoint.form.enterStationsNumber' | translate }}">
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'connectionpoint.category' | translate }}</label>
          <select appInput
                  formControlName="connectionPointCategoryId">
            <option value="null" selected disabled>{{ 'connectionpoint.form.chooseCategory' | translate }}
            </option>
            @for (item of mpTypeList; track item.key) {
              <option [value]="item.key">
                {{ item.value }}
              </option>
            }
          </select>
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'connectionpoint.maximumPower' | translate }}</label>
          <input appInput
                 type="number"
                 formControlName="maximumPower"
                 placeholder="{{ 'connectionpoint.form.enterMaximumPower' | translate }}" append="kW">
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'connectionpoint.maximumCurrent' | translate }}</label>
          <input appInput
                 type="number"
                 formControlName="maximumCurrent"
                 placeholder="{{ 'connectionpoint.form.enterMaximumCurrent' | translate }}" append="A">
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'connectionpoint.description' | translate }}</label>
          <textarea appInput
                    formControlName="description"
                    rows="4"
                    placeholder="{{ 'connectionpoint.form.enterDescription' | translate }}"></textarea>
        </app-input-group>
      </div>
    </app-tab>
    <app-tab
      [title]="'connectionpoint.create.location'"
    >
      <app-address
        [address]="form.get('address')?.value"
        (addressChange)="addressChanged($event)"
      ></app-address>
    </app-tab>
    <app-tab
      [title]="'connectionpoint.key'"
    >
      <div class="flex flex-col" formGroupName="accessKey">
        <app-input-group>
          <label appLabel>{{ 'connectionpoint.keyFields.number' | translate }}</label>
          <input
            appInput
            formControlName="number">
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'connectionpoint.keyFields.placementType' | translate }}</label>
          <input
            appInput
            formControlName="placementType">
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'connectionpoint.keyFields.code' | translate }}</label>
          <input
            appInput
            formControlName="code">
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'connectionpoint.keyFields.remarks' | translate }}</label>
          <textarea
            appInput
            rows="3"
            formControlName="remarks"></textarea>
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'connectionpoint.keyFields.facility' | translate }}</label>
          <input
            appInput
            formControlName="facility">
        </app-input-group>
      </div>
    </app-tab>
  </app-tabs>
</form>
